import { createSlice } from "@reduxjs/toolkit";
import { verifyClaim } from "../../reducer/claimVerify/verifyClaimReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const verifyClaimSlice = createSlice({
  name: "verifyClaim",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(verifyClaim.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(verifyClaim.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || {};
      })
      .addCase(verifyClaim.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default verifyClaimSlice.reducer;
